import type { HourlyTuitionBilling } from '../modal/class';

export const getHourlyTuitionBillingId = (
  billingInfo: HourlyTuitionBilling | string | null,
) => {
  if (!billingInfo) return null;
  return typeof billingInfo === 'object' ? billingInfo._id : billingInfo;
};
